module.exports = __webpack_public_path__ + "static/pixie-live-eab1c38af8d6110df019412f91fb8da8.mp4";